"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapUserInfo = void 0;
function mapUserInfo(user, token = null) {
    if (!user)
        return null;
    const attributes = user.attributes || {};
    const text = (value) => typeof value === 'string' ? value : undefined;
    return {
        userName: text(token?.email) || user.username,
        email: text(attributes.email) || text(token?.email),
        phoneNumber: text(attributes.phone_number) || text(token?.phone_number),
        emailVerified: attributes.email_verified === true || token?.email_verified === true,
        id_parent: text(attributes['custom:id_parent']) || null,
        id_organization: text(attributes['custom:id_organization']) || null,
        id_coupon: text(attributes['custom:coupon']) || null,
        id_sales: text(attributes['custom:id_sales']) || null,
    };
}
exports.mapUserInfo = mapUserInfo;
